import React, { FC } from "react";
import injectSheet from "react-jss";

interface Props {
  classes: any;
}

import styleSheet from "./styles";

const upgradeMessage: FC<Props> = ({ classes }) => {
  return (
    <div className={classes.container}>
      <h2 className={classes.h2}>Legacy Browser Detected</h2>
      <p className={classes.p}>
        Sorry, it appears you are using a browser that is not currently
        supported by our website. Please use one of the following browsers to
        continue to our site: Chrome, Firefox, Safari, Microsoft Edge
      </p>
      <p>
        <a
          className={classes.a}
          href="https://www.google.com/chrome/"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img
            alt="Google Chrome icon (September 2014).svg"
            src="//upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Google_Chrome_icon_%28September_2014%29.svg/64px-Google_Chrome_icon_%28September_2014%29.svg.png"
            decoding="async"
            width="32"
            height="32"
          />
          Chrome
        </a>
      </p>
      <p>
        <a
          className={classes.a}
          href="https://getfirefox.com"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img
            alt="Firefox logo, 2019.svg"
            src="//upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Firefox_logo%2C_2019.svg/68px-Firefox_logo%2C_2019.svg.png"
            decoding="async"
            width="34"
            height="32"
          />
          Firefox
        </a>
      </p>
      <p>
        <a
          className={classes.a}
          href="https://support.apple.com/downloads/safari"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img
            alt="Apple Safari 8.0 Icon"
            src="//upload.wikimedia.org/wikipedia/commons/thumb/5/52/Safari_browser_logo.svg/64px-Safari_browser_logo.svg.png"
            decoding="async"
            width="32"
            height="32"
          />
          Safari
        </a>
      </p>
      <p>
        <a
          className={classes.a}
          href="https://www.microsoft.com/en-us/edge"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img
            alt="Microsoft Edge logo (2019).svg"
            src="//upload.wikimedia.org/wikipedia/en/thumb/9/98/Microsoft_Edge_logo_%282019%29.svg/64px-Microsoft_Edge_logo_%282019%29.svg.png"
            decoding="async"
            width="32"
            height="32"
          />
          Microsoft Edge
        </a>
      </p>
    </div>
  );
};

export const UpgradeMessage = injectSheet(styleSheet)(upgradeMessage);
